/*global history*/
/*eslint no-restricted-globals: ["error", "history"]*/

import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import Auth from './Auth'

class AuthBtn extends Component {
	render() {
		return (
			<div onClick={
				() => {
					Auth.logout();
					this.props.history.push('/')
				}
			}>
				<li>
					<i className="fa fa-sign-out"></i> Log Out
				</li>
			</div>
		)
	}
}

export default withRouter(AuthBtn)


// WEBPACK FOOTER //
// ./src/auth/AuthBtn.js